let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4S1dY")).then(() => parcelRequire('a7NHJ'));